"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgAmenityPaved(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({}, props, {
    viewBox: "0 0 1024 1024",
    fill: "currentColor",
    className: "Icon ".concat(props.className ? props.className : ''),
    ref: svgRef
  }), /*#__PURE__*/React.createElement("path", {
    d: "M544.1 449.4v141.2c0 19.3-12.8 32.1-32.1 32.1s-32.1-16.1-32.1-32.1V449.4c0-19.3 12.8-32.1 32.1-32.1s32.1 12.8 32.1 32.1zM512 706.2c-19.3 0-32.1 12.8-32.1 32.1v141.2c0 16.1 12.8 28.9 32.1 28.9s32.1-12.8 32.1-32.1v-138c0-19.3-12.8-32.1-32.1-32.1zm0-574.6c-19.3 0-32.1 12.8-32.1 32.1V305c0 16.1 12.8 28.9 32.1 28.9s32.1-12.8 32.1-32.1v-138c0-19.3-12.8-32.2-32.1-32.2zM974.2 1024H52.9c-16.1-3.2-25.7-22.5-22.5-38.5l256.8-963C293.7 9.6 303.3 0 319.4 0h385.2c16.1 0 25.7 9.6 32.1 22.5l256.8 963c3.2 19.2-6.4 35.3-19.3 38.5zm-54.5-61L678.9 64.2H345.1L104.3 963h815.4z"
  }));
}

var ForwardRef = React.forwardRef(SvgAmenityPaved);
var _default = ForwardRef;
exports.default = _default;